/*
 * @Author: TYH
 * @Date: 2020-01-12 16:20:11
 * @LastEditTime: 2020-08-04 13:40:33
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\resourceCenter\newspaperRemark\newspaperRemarkList.js
 * @Description: 读报评报列表
 */
'use strict';

angular.module('newspaperRemarkListModule', []).controller('NewspaperRemarkListCtrl', [
    '$scope',
    'trsHttpService',
    '$state',
    '$filter',
    'globleParamsSet',
    'messagePublishService',
    'loginService',
    'resCtrModalService',
    'modalDialog',
    '$q',
    'trsspliceString',
    'jsonArrayToStringService',
    '$sessionStorage',
    function($scope, trsHttpService, $state, $filter, globleParamsSet, messagePublishService, loginService, resCtrModalService, modalDialog, $q, trsspliceString, jsonArrayToStringService, $sessionStorage) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.baseUrl = '/paperreview/paperReviewColumn';
            $scope.status = {
                currentPaper: {}, // 当前报纸信息
                fewDaysAgo: 3, // 时间默认选择前三天的数据
                type: $state.params.type,
                typetwo: $state.params.typetwo,
                order: 'desc',
                // 高亮排序的箭头
                currentOrder: $state.params.typetwo === 'zd' ? 'udesc' : 'desc',
                // 给更新时间一个标识
                updateTimeFlag: false,
            };

            $scope.api = {
                // 请求url集合
                // 手工单列表数据
                queryManualReviewList: $scope.baseUrl + '/queryManualReviewList',
                // 可视化列表数据
                queryVisibleReviewList: $scope.baseUrl + '/queryVisibleReviewList',
                // 删除操作的
                deleteManualReview: $scope.baseUrl + '/deleteManualReview',
                // 查询手工单详情数据的
                queryManualReviewDetail: $scope.baseUrl + '/queryManualReviewDetail',
                // 新建或者保存数据的
                saveOrUpdateManualReview: $scope.baseUrl + '/saveOrUpdateManualReview',
                // 评报管理的api
                getPaperLayoutList: '/paperreview/paperReview/getPaperLayoutList',
                queryVisibleReviewDetail: $scope.baseUrl + '/queryVisibleReviewDetail',
            };
            $scope.page = {
                pageNum: 1,
                pageSize: globleParamsSet.setResourceCenterPageSize,
                pagecount: 1,
                itemcount: 0,
            };
            $scope.params = {
                // serviceid: 'szb',
            };
            $scope.data = {
                items: [], // 列表数据
                // currPage: 1, // 当前页数
                // fromdate: globleParamsSet.dateFormat(globleParamsSet.fewDaysAgo($scope.status.fewDaysAgo)), // 开始时间
                // untildate: globleParamsSet.dateFormat(new Date(), '-'), // 截止时间
                customConfig: {
                    maxDate: globleParamsSet.dateFormat(new Date()),
                },
                selectedArray: [],
                editorData: {},
                userinfo: {},
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            loginService.getCurrLoginUser().then((data) => {
                $scope.data.userinfo = data;
            });
            requestData();
            messagePublishService.subscribe(
                'routerToNewspaperRemarkList',
                function(event, data) {
                    requestData();
                },
                $scope
            );
        }

        /**
         * [getFilterVal description]description：获取过滤信息
         *
         * @param   {[Object]}  key   [key description]
         * @param   {[Object]}  val   [val description]
         * @param   {[type]}  val2  [val2 description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.getFilterVal = function(key, val, val2) {
            // 选择日期以后 重置到第一页
            $scope.page.pageNum = 1;
            // 刷新列表
            requestData();
        };

        /**
         * [getOwnEditorData description]请求自己的信息
         * @param   {[type]}  item  [item description]
         * @param   {[type]}  type  [type description]
         * @param   {[type]}  flag  [type description]
         * @return  {[type]}        [return description]
         */
        function getOwnEditorData(item, type, flag) {
            var getUrl = $scope.api.queryManualReviewDetail;
            if (type === 'zd') {
                getUrl = $scope.api.queryVisibleReviewDetail;
            }
            // 第一步要置空
            $scope.data.editorData = {};
            // 第二步发请求 请求回来以后 调新建编辑页的方法
            var deffer = $q.defer();
            var params = {
                paperReviewId: item.id,
            };
            if (flag) {
                params.isEdit = 1;
            }
            $scope.loadingPromise = globleParamsSet.getTokenService($sessionStorage.get('curUserInfo').TENANTID).then(
                (data) => {
                    trsHttpService.httpServer(getUrl, params, 'get', false, {'token': data.token}).then(
                        (data) => {
                            $scope.data.editorData = data.datas;
                            if (!flag) {
                                item.readcount = item.readcount + 1;
                            }
                            deffer.resolve();
                        });
                }
            );
            return deffer.promise;
        }

        /**
         * [selectAll description] 全选
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
             * [selectDoc description] 单选
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
        $scope.selectDoc = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
        };

        /**
         * [compare description]比较排序
         *
         * @param   {[type]}  property  [property description]
         * @param   {[type]}  bool      [bool description]
         *
         * @return  {[type]}            [return description]
         */
        function compare(property, bool) {
            return function(a, b){
                var value1 = a[property];
                var value2 = b[property];
                if (bool === true) {
                    return value1 < value2 ? 1 : -1;
                } else {
                    return value1 > value2 ? 1 : -1;
                }
                
            };
        }
    
        /**
         * [orderByProperty description]根据某个时间排序
         *
         * @param   {[type]}  property  [property description]
         * @param   {[type]}  bool      [bool description]
         *
         * @return  {[type]}            [return description]
         */
        $scope.orderByProperty = function (property, bool) {
            $scope.status.updateTimeFlag = !$scope.status.updateTimeFlag;
            if (bool) {
                $scope.status.currentOrder = 'udesc';
            } else {
                $scope.status.currentOrder = 'uasc';
            }
            $scope.data.items = $scope.data.items.sort(compare(property, bool));
        };

        /**
         * [selectPageNum description]选择分页条数
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function () {
            requestData();
        };
        
        /**
         * [requestData description] 请求数字报版面列表
         * @return {[type]} [description]
         */
        function requestData() {
            // 根据这个显示对应列表
            $scope.data.selectedArray = [];
            // type用于判断是评报栏还是评报管理
            $scope.status.type = $state.params.type;
            // typetwo用于评报栏中 是手工还是可视化
            $scope.status.typetwo = $state.params.typetwo;
            if ($scope.status.type === 'pbl') {
                requesthandle($scope.status.typetwo);
            } else {
                var params = {
                    pageSize: 10,
                    pageNum: $scope.page.pageNum,
                    keyword: {
                        time: getFilterDate($scope.data.untildate) ? getFilterDate($scope.data.fromdate) + ',' + getFilterDate($scope.data.untildate) : '',
                        keywords: $state.params.sitename,
                    },
                    user_id: $scope.data.userinfo.ID,
                };
                // loginService.getCurrLoginUser().then((data) => {
                //     params.user_id = data.ID;
                // });
                // params.paperid = $state.params.paperid;
                // params.user_id = $scope.data.userinfo.ID;
                params = jsonArrayToStringService.jsonArrayToString(params);
                $scope.loadingPromise = globleParamsSet.getTokenService($sessionStorage.get('curUserInfo').TENANTID).then(
                    (data) => {
                        trsHttpService.httpServer($scope.api.getPaperLayoutList, params, 'post', false, {'token': data.token}).then(function(data) {
                            $scope.data.items = data.datas;
                            $scope.page = data.summary_info;
                        });
                    }
                );
            }
        }

        /**
         * [getVisibleHoverTitle description]循环给td加一个title
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function getVisibleHoverTitle(data) {
            angular.forEach(data, function (item, index) {
                item.hoverRemarkTitle = '';
                angular.forEach(item.paperlayoutstatics, function (items, indexs) {
                    if (item.paperlayoutstatics.length === 1) {
                        item.hoverRemarkTitle = items.bcandscore;
                    } else {
                        indexs === item.paperlayoutstatics.length - 1 ? item.hoverRemarkTitle += items.bcandscore + '。' : item.hoverRemarkTitle += items.bcandscore + '，';
                    }
                });
            });
        }

        /**
         * [requesthandle description]获取评报栏列表数据
         *
         * @param   {[type]}  type  [type description]
         *
         * @return  {[type]}        [return description]
         */
        function requesthandle(type) {
            var requestUrl = $scope.api.queryManualReviewList;
            if (type === 'zd') {
                requestUrl = $scope.api.queryVisibleReviewList;
            }
            var params = {
                pageSize: $scope.page.pageSize,
                pageNum: $scope.page.pageNum,
                startTime: getFilterDate($scope.data.fromdate),
                endTime: getFilterDate($scope.data.untildate),
                siteName: $scope.status.currentPaper.SITEDESC || $state.params.sitename,
                order: $scope.status.order,
            };
            $scope.loadingPromise = globleParamsSet.getTokenService($sessionStorage.get('curUserInfo').TENANTID).then(
                (data) => {
                    trsHttpService.httpServer(requestUrl, params, 'get', false, {'token': data.token}).then(function(data) {
                        $scope.data.items = data.datas;
                        if (type === 'zd') {
                            getVisibleHoverTitle($scope.data.items);
                        }
                        $scope.page = data.summary_info;
                    });
                }
            );
        }

        /**
         * [pageChanged description]点击分页 刷新下列表
         *
         * @return  {[type]}  [return description]
         */
        $scope.pageChanged = function() {
            requestData();
        };

        /**
         * [getzddata description]获得可视化的详情页
         * @param   {[type]}  item  [item description]
         * @param   {[type]}  type  [type description]
         * @return  {[type]}        [return description]
         */
        $scope.getzddata = function (item, type) {
            getOwnEditorData(item, type).then(function () {
                let options = $scope.data.editorData;
                options.windowTitle = '阅评报告详情';
                resCtrModalService.commentModal(options, 'commentzddetail');
            });
        };

        /**
         * [getFilterDate description]拿到的日期
         *
         * @param   {[type]}  date  [date description]
         *
         * @return  {[type]}        [return description]
         */
        function getFilterDate(date) {
            var FilterDate = $filter('date')(date, 'yyyy-MM-dd') ? $filter('date')(date, 'yyyy-MM-dd').toString() : '';
            return FilterDate;
        }

        /**
         * [getzddata description]获得手工单的详情页
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.getsddata = function (item) {
            getOwnEditorData(item).then(function () {
                $scope.data.editorData.windowTitle = '阅评报告详情';
                $scope.data.editorData.content = $scope.data.editorData.content.replace(/[\n\r]/g, '<br>');
                resCtrModalService.commentModal($scope.data.editorData, 'commentsddetail');
            });
        };

        /**
         * [getOrder description]排序操作
         * @param   {[type]}  $event  [type description]
         * @param   {[type]}  type  [type description]
         * @return  {[type]}        [return description]
         */
        $scope.getOrder = function () {
            $scope.status.currentOrder = $scope.status.order = $scope.status.order === 'asc' ? 'desc' : 'asc';
            requestData();
        };

        /**
         * [deleteRemark description]删除手工单操作
         *
         * @param   {[type]}  item  [item description]要删除的东西
         *
         * @return  {[type]}        [return description]
         */
        $scope.deleteRemark = function (item) {
            modalDialog.confirmModal(
                '删除',
                '确认删除?',
                function() {
                    var array = angular.isDefined(item) ? [item] : $scope.data.selectedArray;
                    var params = {
                        ids: trsspliceString.spliceString(array, 'id', ',')
                    };
                    $scope.loadingPromise = globleParamsSet.getTokenService($sessionStorage.get('curUserInfo').TENANTID).then(
                        (data) => {
                            trsHttpService.httpServer($scope.api.deleteManualReview, params, 'get', false, {'token': data.token}).then(
                                function (data) {
                                    modalDialog.alertType('删除成功', '', 'success', false, function () {
                                        requestData();
                                    });
                                });
                        }
                    );
                },
                function() {
                }
            );
        };

        /**
         * [editorcomment description]编辑评论
         *
         * @param   {[type]}  item  [item description]
         * @param   {[type]}  flag  [flag description]
         * @return  {[type]}        [return description]
         */
        $scope.editorcomment = function (item, flag) {
            getOwnEditorData(item, 'sd', flag).then(
                function () {
                    $scope.newComment(item);
                },
                function () {
                    modalDialog.alertType('阅评', '保存失败', 'error');
                });
        };

        
        /**
        * [newComment description]新建或编辑阅评报告
        *
        * @param   {[type]}  item  [item description]
        *
        * @return  {[type]}        [return description]
        */
        $scope.newComment = function (item) {
            if (item) {
                $scope.data.editorData.windowTitle = '编辑阅评报告';
            } else {
                $scope.data.editorData.windowTitle = '新建阅评报告';
                $scope.data.editorData.content = '';
                $scope.data.editorData.title = '';
            }
            resCtrModalService.commentModal($scope.data.editorData, 'comment').then(
                function (comment) {
                    var params = {
                        id: item ? item.id : '',
                        content: comment.data.data.content,
                        siteName: $scope.status.currentPaper.SITEDESC || $state.params.sitename,
                        title: comment.data.data.title,
                        userName: $scope.data.userinfo.TRUENAME,
                    };
                    $scope.loadingPromise = globleParamsSet.getTokenService($sessionStorage.get('curUserInfo').TENANTID).then(
                        (data) => {
                            trsHttpService.httpServer($scope.api.saveOrUpdateManualReview, params, 'post', false, {'token': data.token})
                                .then(() => {
                                    requestData();
                                });
                        }
                    );
                },
                function () {
                    modalDialog.alertType('阅评报告', '保存失败', 'error');
                });
        };

        /**
         * [toPreviewDetail description]数字报版面样式-初始化请求数据
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.toPreviewDetail = function(item) {
            var router;
            router = $state.href('newspaperRemarkDetail', {
                nodeid: item.ir_order,
                bc: item.bc,
                docpubtime: item.ir_urltime,
                papername: item.ir_sitename,
            });
            window.open(router + '&' + Math.random());
        };
    },
]);
